import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'
import { CIMSModuleItem } from '../../CIMSModule/CIMSModuleItem'

export class InternalPayItemConnectionClassTypeItem<
  ID extends string,
  ClassType extends
    | 'FieldDesignChange'
    | 'ConstructionAdminSubmittal'
    | 'ConcreteTestSet'
    | 'DesignSubmittal'
    | 'Issue'
    | 'EngineeringJudgement',
  ModuleID extends string,
  ModuleName extends string,
  ModulePathname extends string
> extends ComplexEnumItem<ID> {
  module: CIMSModuleItem<ModuleID, ModuleName, ModulePathname>
  classType: ClassType
  constructor({
    id,
    module,
    classType,
  }: Pick<
    InternalPayItemConnectionClassTypeItem<
      ID,
      ClassType,
      ModuleID,
      ModuleName,
      ModulePathname
    >,
    'id' | 'classType' | 'module'
  >) {
    super(id)
    this.module = module
    this.classType = classType
  }
}
